/**
 * Membership enum value → the label a person reads (Change SRS §2, CH-ROLE-1).
 *
 * The enum keeps its PlayStudio values by CH-FORK-5 — renaming them would be a
 * migration for no demo value. But the raw value must never reach the screen:
 * "cxo" was rendering in the sidebar and the workspace switcher on every page.
 */
const ROLE_LABELS: Record<string, string> = {
  cxo: "Supervisor",
  operator: "Team member",
  reviewer: "Compliance reviewer",
  agent_handler: "Agent handler",
  approver: "Approver",
  owner: "Owner",
  staff: "Xamun staff",
};

export function roleLabel(role: string | null | undefined): string {
  if (!role) return "—";
  return ROLE_LABELS[role] ?? role;
}
